<template>
    <component :is="component">
        <slot/>
    </component>
</template>

<style>
    @font-face {
        font-family: 'regularFont';
        src: url('./assets/fonts/neris-light.otf') format('opentype');
        font-weight: normal;
    }

    @font-face {
        font-family: 'boldFont';
        src: url('./assets/fonts/neris-black.otf') format('opentype');
        font-weight: bold;
    }

    html {
        background-color: #000;
    }

    .application {
        font-family: regularFont;
        background-color: transparent !important;
        font-size: 14px;
        color: #fff !important;
    }

    .swal2-container {
        font-family: regularFont;
    }

    .text-bold {
        font-family: boldFont;
    }

    .container {
        padding: 20px !important;
        height: 100%;
    }

    button {
        font-family: boldFont;
        text-transform: initial !important;
    }

    button:not(.radius-inline) {
        border-radius: 25px !important;
    }

    a {
        text-decoration: underline;
    }

    .app-container {
        padding: 40px !important;
        max-width: 800px;
        height: 100%;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
    }

    .app-error-info {
        font-size: 14px;
        color: #888;
        text-align: center;
        padding: 20px;
    }

    .app-error-info>div {
        margin-top: 5px;
    }

    .app-container-flex {
        justify-content: center;
        align-items: center;
        text-align: center;
    }

    .app-image {
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        padding-bottom: 20px;
    }

    .app-image img {
        height: 80px;
    }

    .app-title {
        font-size: 18px;
        text-align: center;
        margin-bottom: 40px;
    }

    .app-title-icon {
        width: 40px;
        height: 40px;
        margin: 0 auto 15px;
        background-color: #fff;
        border-radius: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .app-title-icon-element {
        font-size: 25px;
    }

    .app-footer {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin: 40px 0 20px;
    }

    .app-footer>div {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .app-footer button svg:first-child {
        margin-right: 7px;
    }

    .app-footer button {
        width: 100%;
        margin: 5px 0;
        font-size: 16px !important;
        height: 40px;
    }

    .form-row {
        margin: 15px 0;
        padding: 5px 0;
        position: relative;
    }

    .form-row-title {
        display: flex;
        margin-bottom: 5px;
    }

    .form-row .v-input {
        padding: 0 !important;
        margin: 0 !important;
    }

    .form-row>div {
        min-height: 40px !important;
        height: 40px !important;
        max-height: 40px !important;
    }

    .form-row .v-input .v-input__control {
        margin: 0 !important;
        min-height: 40px !important;
        height: 40px !important;
        max-height: 40px !important;
    }

    .form-row .v-input .v-input__slot {
        margin: 0 !important;
        min-height: 100% !important;
        height: 100% !important;
        max-height: 100% !important;
        box-shadow: none !important;
        outline: none !important;
    }

    .form-row .v-input .v-input__slot {
        background-color: #fff !important;
    }

    .form-row .v-text-field--outline>.v-input__control>.v-input__slot {
        background-color: #fff !important;
    }

    .form-row .v-input input {
        margin: 0 !important;
        padding-top: 0 !important;
        padding-bottom: 0 !important;
        min-height: 100% !important;
        height: 100% !important;
        max-height: 100% !important;
    }

    .form-row .v-input .v-input__append-inner {
        margin-top: 7px !important;
    }

    .form-row-input-password input {
        padding: 0 40px 0 12px !important;
    }

    .form-row-password-icon {
        position: absolute;
        top: 40px;
        right: 10px;
        cursor: pointer;
        color: #888;
    }

    .v-dialog {
        margin: 0 auto !important;
    }
</style>

<script>
    import VuebaseLayout from './layouts/VuebaseLayout'
    import Utils from './services/Utils'

    export default {
        name: 'App',
        components: {
            VuebaseLayout
        },
        computed: {
            component() {
                return VuebaseLayout
            }
        },
        beforeMount: function () {
            Utils.initialize()
        }
    }
</script>
